import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const SHARE_HOUSE_SOURCES_B = [
  {
    sourceId: "share-house-source-change",
    topicId: "share-house",
    title: "Change of shared tenancy arrangement form",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rental-forms-surveys-and-data/resources/change-of-shared-tenancy-arrangement-form",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 form page에서 residential online or paper bond의 co-tenant 변경을 Rental Bonds에 알리는 절차와 2025-02-12 최신 form을 확인",
    reviewStatus: "live_verified",
    claimScope: "공동 tenancy의 principal/co-tenant와 bond record 변경",
    followUp: "모든 parties 서명, 새 principal tenant acceptance와 current form version 확인",
  },
  {
    sourceId: "share-house-source-notice",
    topicId: "share-house",
    title: "Minimum notice periods for ending a residential tenancy",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/minimum-notice-periods-for-ending-a-residential-tenancy",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 agreement·ground·sender별 notice가 다르고 co-tenant가 자신의 tenancy를 끝낼 때의 현재 minimum notice를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW residential tenancy와 co-tenancy 종료의 현재 notice 구조",
    followUp: "fixed/periodic status, statutory ground, service method와 2025 이후 법 개정 재확인",
  },
  {
    sourceId: "share-house-source-boarding",
    topicId: "share-house",
    title: "Living in a boarding house",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/community-living/boarding-houses/living-a-boarding-house",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 boarder/lodger가 tenant와 다른 지위이며 occupancy agreement, deposit cap, receipts, reasonable written eviction notice와 NCAT 경로를 확인",
    reviewStatus: "live_verified",
    claimScope: "registrable NSW boarding house resident의 occupancy principles와 deposit·termination 권리",
    followUp: "premises가 registrable boarding house인지와 실제 agreement가 tenancy인지 occupancy인지 확인",
  },
  {
    sourceId: "share-house-source-ncat-tenancy",
    topicId: "share-house",
    title: "Tenancy and social housing",
    publisher: "NSW Civil and Administrative Tribunal",
    url: "https://ncat.nsw.gov.au/case-types/housing-and-property/tenancy.html",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NCAT 공식 본문에서 residential tenancy disputes, termination, bond, money, repairs, access·privacy orders와 application 경로를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW landlord-tenant disputes에 대해 NCAT가 할 수 있는 orders와 신청 경로",
    followUp: "신청 전 jurisdiction, time limit, respondent name, evidence와 current fee 확인",
  },
  {
    sourceId: "share-house-source-ncat-boarding",
    topicId: "share-house",
    title: "Boarding houses",
    publisher: "NSW Civil and Administrative Tribunal",
    url: "https://ncat.nsw.gov.au/case-types/housing-and-property/strata-and-community-living/boarding-houses.html",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NCAT 공식 본문에서 registrable boarding-house occupancy principles, compensation·money orders와 Consumer and Commercial Division 절차를 확인",
    reviewStatus: "live_verified",
    claimScope: "registrable boarding-house disputes의 NCAT orders와 application 경로",
    followUp: "Fair Trading에 registrable status를 확인하고 requested order·supporting facts를 정리",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of SHARE_HOUSE_SOURCES_B) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
